import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "\n      bg-white\n      flex flex-col\n      text-12px\n      xxl:text-14px\n      overflow-hidden\n      h-screen\n      relative\n      font-montserrat\n    " }
const _hoisted_2 = { class: "flex flex-row text-12px xxl:text-14px items-center" }
const _hoisted_3 = { class: "\n            font-semibold\n            text-20px\n            mr-8\n            whitespace-no-wrap\n            text-black-lp-200\n            capitalize\n          " }
const _hoisted_4 = { class: "flex mt-4" }
const _hoisted_5 = {
  key: 2,
  class: "overflow-auto mt-4"
}
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-montserrat font-semibold text-14px text-gray-lp-300" }, " Status Klaim ", -1)
const _hoisted_8 = { class: "flex flex-col mt-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-montserrat font-semibold text-14px text-gray-lp-300 mt-4" }, " Kategori ", -1)
const _hoisted_10 = { class: "flex flex-col mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Search = _resolveComponent("Search")!
  const _component_advance_filter = _resolveComponent("advance-filter")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_PagePopupDetail = _resolveComponent("PagePopupDetail")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_lp_radio = _resolveComponent("lp-radio")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_BottomSheet = _resolveComponent("BottomSheet")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_breadcrumb),
      _createVNode(_component_Header, null, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("claim.title")), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('claim.searchPlaceholderResi')
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_advance_filter, { onOpenFilterPopUp: _ctx.openFilterPopUp }, null, 8, ["onOpenFilterPopUp"])
      ]),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.onRequest
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_ctx.dataClaims.length === 0 && _ctx.firstRequest && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              data: _ctx.$t('claim.title')
            }, null, 8, ["data"]))
          : (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_TableV2, {
                loading: _ctx.isLoading,
                borderTop: false,
                borderBottom: false,
                columns: _ctx.columns,
                data: _ctx.dataClaims,
                class: "my-2",
                onClick: _ctx.onClickRow,
                isDetailAble: _ctx.isDetailAble,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
                onRequest: _ctx.onRequest,
                onTryAgain: _ctx.onRequest,
                paginationStyle: "v3"
              }, null, 8, ["loading", "columns", "data", "onClick", "isDetailAble", "pagination", "onRequest", "onTryAgain"])
            ]))
    ]),
    _createVNode(_component_Dialog, {
      title: _ctx.$t('claim.claimStatus'),
      modelValue: _ctx.dialogDetailClaim,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogDetailClaim = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PagePopupDetail, { dataDetailClaim: _ctx.dataDetailClaim }, null, 8, ["dataDetailClaim"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_BottomSheet, {
      modelValue: _ctx.isSheetOpen,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSheetOpen = $event)),
      title: "Filter",
      isUsingReset: true,
      isReset: _ctx.isAnyFilterSelected,
      onOnFilterReset: _ctx.resetClaimFilter
    }, {
      default: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_lp_radio, {
                name: "claimStatus",
                options: _ctx.claimStatusOptions,
                labels: _ctx.claimStatusLabels,
                modelValue: _ctx.claimStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.claimStatus = $event)),
                customClass: "py-3 border-b border-gray-lp-400 items-center"
              }, null, 8, ["options", "labels", "modelValue"])
            ]),
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_lp_radio, {
                name: "claimCategory",
                options: _ctx.claimCategoryOptions,
                labels: _ctx.claimCategoryLabels,
                modelValue: _ctx.claimCategory,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.claimCategory = $event)),
                customClass: "py-3 border-b border-gray-lp-400 items-center"
              }, null, 8, ["options", "labels", "modelValue"])
            ]),
            _createVNode(_component_lp_button, {
              "text-color": "white",
              title: _ctx.$t('claim.apply'),
              customClass: "w-full mt-4 py-3",
              onClick: _ctx.onSelectClaimFilter
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "isReset", "onOnFilterReset"])
  ], 64))
}